module.exports = __webpack_public_path__ + "static/media/banner.ef26f8b6.png";